import MSAuth from './MSAuth';

export default MSAuth;
